import VueI18n from "vue-i18n";
import Vue from "vue";
import en from '@translations/search/search.en.json';
import zh from '@translations/search/search.zh.json';


Vue.use(VueI18n);

export default new VueI18n({
    locale: window.imaios.getSiteAccess(),
    messages: {
        en,
        cn: zh
    }
});
